import { render, staticRenderFns } from "./StartAndEnd.vue?vue&type=template&id=6ff01172&scoped=true&"
import script from "./StartAndEnd.vue?vue&type=script&lang=js&"
export * from "./StartAndEnd.vue?vue&type=script&lang=js&"
import style0 from "./StartAndEnd.vue?vue&type=style&index=0&id=6ff01172&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff01172",
  null
  
)

export default component.exports